import { Text, Image } from '@kidslabs/mario-nextjs-react-ui-core';
import { useMemo } from 'react';

import styles from './login-form-footer.module.css';

export const LoginFormFooter = () => {
    const footerImageProps = useMemo(
        () => ({
            // handle use url from cdn
            //src: getImageAssetUrl('images/logo-2-rows.png'),
            src: '/assets/images/logo-2-rows.png',
            alt: 'Logo Kidsplaza',
            objectFit: 'cover' as const,
            style: { objectPosition: 'center' },
        }),
        []
    );

    return (
        <div className={styles.container}>
            <Text className={styles.text}>Design by</Text>
            <Image {...footerImageProps} className={styles.logo} />
        </div>
    );
};
